<template lang="pug">
options
  v-list-tile(:to='{ name: "lease details", params: { leaseId: lease.id } }')
    v-icon(color='green') fas fa-eye
    | Aanvraag wijzigen

  v-list-tile(@click='rerunExports', v-if='$store.getters["organization/hasExports"]')
    v-icon(color='green') fab fa-telegram-plane
    | Opnieuw exporteren

  v-list-tile(@click='rerunCustomerMail')
    v-icon(color='green') fas fa-envelope
    | Opnieuw klant mailen

  v-list-tile(@click='downloadAsPdf')
    v-icon(color='green') fas fa-file-pdf
    | PDF downloaden

  v-divider

  v-list-tile(@click='deleteLease')
    v-icon(color='red darken-2') fas fa-trash-alt
    | Verwijderen
</template>

<script>
import { exportMethodsEnum } from '@/helpers/constants'

export default {
  props: {
    lease: Object
  },

  components: {
    Options: require('@/components/Table/Options').default
  },

  computed: {
    currentExportMethods () {
      return this.$store.state.organization.current.exportMethods
    }
  },

  methods: {
    async deleteLease () {
      await this.$root.$confirm('Verwijderen', `Weet je zeker dat je de lease met nummer ${this.lease.number} permanent wil verwijderen?`, { color: 'red', confirmLabel: 'Verwijderen' })

      await this.$store.dispatch('graphqlMutation', {
        name: 'deleteLease',
        variables: {
          id: this.lease.id
        }
      })

      this.$emit('deleted', this.lease.id)

      this.$root.$snackbar.show(`Lease ${this.lease.number} is verwijderd`)
    },

    async rerunExports () {
      let msg = `Weet je zeker dat je de lease met nummer ${this.lease.number} opnieuw wil exporteren?

De volgende exports zullen uitgevoerd worden:
`

      for (const ex of this.currentExportMethods) {
        msg += `  ➡️ ${Object.values(exportMethodsEnum).find(x => x.method === ex.method).text}\n`
      }

      await this.$root.$confirm('Opnieuw exporten', msg, { color: 'primary', confirmLabel: 'Exporteren' })

      await this.$store.dispatch('graphqlMutation', {
        name: 'rerunLeaseExports',
        variables: {
          id: this.lease.id
        },
        deleteCacheQueries: ['getAllLeases', 'getAllBusinessLeases', 'getAllPrivateLeases']
      })

      this.$root.$snackbar.show('Exports zijn opnieuw uitgevoerd')
    },

    async rerunCustomerMail () {
      let msg = `Weet je zeker dat je de lease met nummer ${this.lease.number} opnieuw naar de klant wil mailen?

De klant zal een nieuwe e-mail ontvangen met de lease PDF en eventuele documenten als bijlage.`

      await this.$root.$confirm('Opnieuw exporten', msg, { color: 'primary', confirmLabel: 'Verstuur mail' })

      await this.$store.dispatch('graphqlMutation', {
        name: 'rerunCustomerMail',
        variables: {
          id: this.lease.id
        }
      })

      this.$root.$snackbar.show('Klant mail opnieuw verstuurd')
    },

    async downloadAsPdf () {
      const pdfAsBase64 = await this.$store.dispatch('graphqlQuery', {
        name: 'downloadLeaseAsPdf',
        variables: {
          id: this.lease.id
        }
      })

      this.$store.dispatch('files/downloadBase64', {
        base64: pdfAsBase64,
        name: this.lease.number + '.pdf',
        fileType: 'application/pdf'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
